// extracted by mini-css-extract-plugin
export default {"alert":"form-alert_alert__eOVPs","success":"form-alert_success__EfR-o","info":"form-alert_info__4KS4V","closeBtn":"form-alert_closeBtn__SvMf+"};